<div class="row">
  <div class="col-md-12 matches-nav">
    <div>
      <a class="mat-select-button" [class.selected]="upcomingSelected"
         routerLink="/spiele/kommende">Kommende Spiele</a>
      <a class="mat-select-button" [class.selected]="!upcomingSelected"
         routerLink="/spiele/vergangene">Vergangene Spiele</a>
    </div>
  </div>
</div>
<div class="content-container">
  <lib-games-list *ngIf="games?.length > 0"
                  [user]="user"
                  [live]="true"
                  [showLeagueInfo]="true"
                  [sortByRound]="true"
                  [showDate]="true"
                  [showStatus]="true"
                  [showReporterStatus]="true"
                  [showAds]="true"
                  [hideShadow]="true"
                  [openLinksInNewTab]="false"
                  [events]="games"></lib-games-list>
  <button mat-raised-button class="load-more"
          *ngIf="games?.length < totalCount && !loading"
          (click)="loadMore()">
    Mehr Spiele laden
  </button>
  <span *ngIf="!loading && games?.length === 0" class="empty-games">
    Keine Spiele vorhanden
  </span>
</div>
<div class="spinner-container">
  <mat-spinner *ngIf="loading" strokeWidth="2" color="primary" diameter="54" class="m-auto"></mat-spinner>
</div>
